module.exports = __webpack_public_path__ + "img/sessions.9827bc9.png";